export const SET_MANAGED_SERVICE = 'SET_MANAGED_SERVICE'

export const MANAGED_SERVICE_KEY = 'MANAGED_SERVICE_KEY'
